import { render, staticRenderFns } from "./ResidenceHeader.vue?vue&type=template&id=7408e7d6&scoped=true&"
import script from "./ResidenceHeader.vue?vue&type=script&lang=js&"
export * from "./ResidenceHeader.vue?vue&type=script&lang=js&"
import style0 from "./ResidenceHeader.vue?vue&type=style&index=0&id=7408e7d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7408e7d6",
  null
  
)

export default component.exports